module.exports = __webpack_public_path__ + "img/vastgoedjournaal.40be3ed6.png";